import { render, staticRenderFns } from "./cirokaranalizi.vue?vue&type=template&id=f6770464&"
import script from "./cirokaranalizi.vue?vue&type=script&lang=js&"
export * from "./cirokaranalizi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports